export enum WithdrawalStatus {
  Pending = "pending",
  Completed = "completed",
  RequiresMerchantAction = "requires_merchant_action",
  Failed = "failed",
}
